var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatalogMenu2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7198 13.8187C13.0832 13.8187 12.4652 13.9014 11.8755 14.0572L17.0337 2.35376C17.2326 1.94184 17.564 1.94184 18.0279 2.1478C18.2191 2.23515 18.4097 2.32299 18.6 2.41124C18.6006 3.00909 18.926 3.58466 19.486 3.79562L25.0535 6.1298C25.7826 6.40441 26.6442 6.06115 26.9093 5.30598C27.1744 4.5508 26.843 3.65832 26.114 3.38371L20.6128 1.04952C20.3376 0.94586 20.0435 0.930245 19.7661 0.991597L18.4256 0.362832C16.3608 -0.60933 15.8908 0.498775 15.1755 2.18537C15.1331 2.28526 15.0898 2.38742 15.0454 2.49106C14.101 4.70111 13.2119 6.71995 12.3198 8.73931C11.4069 8.05192 10.0744 8.05191 10.0744 8.05191C10.0744 8.05191 5.36862 7.84596 3.24768 8.05191C1.52103 8.24526 1.3058 8.77894 1.09828 9.29352C1.01106 9.50979 0.925202 9.72269 0.729072 9.90553H7.22444C8.28491 9.90553 7.29072 11.7591 6.29653 11.7591H0.198838L0 13.0635H6.6942C7.68839 13.0635 6.82676 14.9858 5.83257 14.9858H0.132559V15.3977L1.9221 17.8168V21.0958H6.3001L6.29649 21.1645H7.29068C7.29199 21.1416 7.2934 21.1187 7.29492 21.0958H8.22014C8.21911 21.1415 8.21859 21.1873 8.21859 21.2332C8.21859 24.3912 10.7372 27 13.786 27C16.8349 27 19.3535 24.3912 19.3535 21.2332C19.3535 18.0752 16.8349 15.4664 13.786 15.4664C12.3605 15.4664 11.0738 16.0127 10.0973 16.908H9.08049C10.2489 15.641 11.891 14.8485 13.7198 14.8485C17.1663 14.8485 19.95 17.6633 20.1489 21.1645H21.143C20.9442 17.0454 17.6965 13.8187 13.7198 13.8187ZM16.5035 21.3019C16.5035 19.7228 15.3105 18.4871 13.786 18.4871C12.2616 18.4871 11.0686 19.7228 11.0686 21.3019C11.0686 22.8809 12.2616 24.1166 13.786 24.1166C15.3105 24.1166 16.5035 22.8809 16.5035 21.3019Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 13.5,
    y1: 0,
    x2: 13.5,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28F14"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogMenu2);
export default __webpack_public_path__ + "static/media/catalog-menu-2.2886aae93c4c81d320a6ec1c4253dbd0.svg";
export { ForwardRef as ReactComponent };